export const formatCurrency = (number: number, fixed: number = 0) => {
  return fixed > 0
    ? number && number.toString().replace(`/B(?=(d{${fixed}})+(?!d))/g`, ",")
    : Math.round(((number + Number.EPSILON) * 100) / 100)
        .toString()
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};
